import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { MetaMaskProvider } from "@metamask/sdk-react";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <MetaMaskProvider
            debug={false}
            sdkOptions={{
                dappMetadata: {
                    name: "MiERO - MiEROS NFT Dapp",
                    url: window.location.href,
                },
                // Other options
            }}
        >
            <App />
        </MetaMaskProvider>
    </React.StrictMode>
);